import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_DASHBOARD_MATRIX, GET_VENDOR_DASHBOARD_MATRIX_SUCCESS, GET_VENDOR_DASHBOARD_MATRIX_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';

function* getVendorDashboardMatrix({ payload }) {
  try {
    // Sibling /v2/vendor/* endpoints (car-type, car-regions, chauffeur, dashboard) all strip this header —
    // it isn't in this backend route's CORS allow-list, so leaving it in blocks the request/cookies.
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/dashboard-matrix`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_DASHBOARD_MATRIX_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_DASHBOARD_MATRIX_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_DASHBOARD_MATRIX_ERROR, payload: error });
  }
}

export function* watchGetVendorDashboardMatrix() {
  yield takeEvery(GET_VENDOR_DASHBOARD_MATRIX, getVendorDashboardMatrix);
}

function* getVendorDashboardMatrixSaga() {
  yield all([fork(watchGetVendorDashboardMatrix)]);
}

export default getVendorDashboardMatrixSaga;
